import { render, staticRenderFns } from "./PhotoStream.vue?vue&type=template&id=53ed891b&scoped=true&"
import script from "./PhotoStream.vue?vue&type=script&lang=ts&"
export * from "./PhotoStream.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed891b",
  null
  
)

export default component.exports